import React from 'react'

import { useShallow } from 'zustand/react/shallow'

import { cn } from 'utils/utils'

import {
  MAX_HIGHLIGHT_CHARACTER_LENGTH,
  MIN_HIGHLIGHT_CHARACTER_LENGTH,
  RequestMode,
} from '../../../../utils/constants'
import { useRequestMode } from '../../hooks/useRequestMode'
import useAppStore from '../../stores/store'

export const SelectedTextDisplay = () => {
  const mode = useRequestMode()
  const { highlightedText } = useAppStore(
    useShallow((s) => ({
      highlightedText: s.highlightedText,
    }))
  )

  const selectedCharactersText = (() => {
    if (!highlightedText || mode === RequestMode.INSERT) {
      return <span className="text-xs">No text highlighted</span>
    }
    if (highlightedText?.text.length < MIN_HIGHLIGHT_CHARACTER_LENGTH) {
      return (
        <span className="text-xs text-destructive">
          {MIN_HIGHLIGHT_CHARACTER_LENGTH} character minimum
        </span>
      )
    }
    return (
      <div className="text-xs">
        <span
          className={cn('text-xs', {
            'text-destructive':
              highlightedText?.text.length > MAX_HIGHLIGHT_CHARACTER_LENGTH,
          })}
        >
          {highlightedText?.text.length.toLocaleString()}
        </span>
        <span className="text-xs text-muted">
          {' '}
          of {MAX_HIGHLIGHT_CHARACTER_LENGTH.toLocaleString()} characters
        </span>
      </div>
    )
  })()

  return (
    <div className="flex items-center justify-between rounded bg-accent px-2 py-1">
      {highlightedText?.text && (
        <span className="max-w-[50%] truncate text-xs">
          {highlightedText.text}
        </span>
      )}
      {selectedCharactersText}
    </div>
  )
}
